/* Printtex — transfert du fichier préparé sur la page « Préparer mon visuel » vers la fiche Feuille DTF ('dtf') ou
   l'outil de personnalisation ('perso'). Le fichier reste dans le navigateur : IndexedDB, ou sessionStorage (même onglet)
   si IndexedDB est indisponible (navigation privée). Repris une seule fois, par sa destination seulement ; ignoré après 15 min.
   Script classique (pas un module) : window.ptxTransfert = { deposer(blob, nom, dest), reprendre(dest) }.
   Erreur Error('trop-gros') si le fichier ne tient pas dans sessionStorage. */
(() => {
  const BASE = 'printtex-visuel', MAGASIN = 'transfert', CLE = 'dernier', SS = 'ptx-visuel-transfert';
  const DUREE = 15 * 60 * 1000;
  const ouvrir = () => new Promise((ok, ko) => {
    if (!window.indexedDB) return ko(new Error('indisponible'));
    const r = indexedDB.open(BASE, 1);
    r.onupgradeneeded = () => r.result.createObjectStore(MAGASIN);
    r.onsuccess = () => ok(r.result);
    r.onerror = () => ko(r.error);
  });
  const versDataUrl = (blob) => new Promise((ok) => { const r = new FileReader(); r.onload = () => ok(r.result); r.readAsDataURL(blob); });

  async function deposer(blob, nom, dest) {
    const v = { blob, nom, type: blob.type, dest, t: Date.now() };
    try {
      const db = await ouvrir();
      await new Promise((ok, ko) => { const t = db.transaction(MAGASIN, 'readwrite'); t.objectStore(MAGASIN).put(v, CLE); t.oncomplete = ok; t.onerror = () => ko(t.error); });
      db.close(); return;
    } catch (e) { /* repli ci-dessous */ }
    try { sessionStorage.setItem(SS, JSON.stringify({ ...v, blob: await versDataUrl(blob) })); } catch (e) { throw new Error('trop-gros'); }
  }

  // Lecture et effacement dans la même transaction : deux onglets ne reprennent pas le même fichier.
  async function reprendre(dest) {
    let v = null;
    try {
      const db = await ouvrir();
      v = await new Promise((ok, ko) => {
        const t = db.transaction(MAGASIN, 'readwrite'), s = t.objectStore(MAGASIN), r = s.get(CLE);
        let trouve = null;
        r.onsuccess = () => { trouve = r.result || null; if (trouve && trouve.dest === dest) s.delete(CLE); };
        t.oncomplete = () => ok(trouve); t.onerror = () => ko(t.error);
      });
      db.close();
    } catch (e) { /* repli ci-dessous */ }
    if (!v) {
      const brut = sessionStorage.getItem(SS);
      if (brut) { const o = JSON.parse(brut); if (o.dest === dest) { sessionStorage.removeItem(SS); v = { ...o, blob: await (await fetch(o.blob)).blob() }; } }
    }
    if (!v || v.dest !== dest || Date.now() - v.t > DUREE) return null;
    return new File([v.blob], v.nom, { type: v.type });
  }

  window.ptxTransfert = { deposer, reprendre };
})();
